import React, { useState } from 'react';
import CharacterBuild from './CharacterBuild';
import DamageCalculator from './DamageCalculator';
import Charts from './Charts';

const CalculatorDashboard = ({ darkMode }) => {
  const [characterStats, setCharacterStats] = useState({
    strength: 0,
    defense: 0,
    stamina: 0,
    fruitMastery: 0,
    swordMastery: 0,
    level: 1
  });
  
  const [selectedFruit, setSelectedFruit] = useState(null);
  const [selectedWeapon, setSelectedWeapon] = useState(null);
  const [damageOutput, setDamageOutput] = useState(null);
  
  const handleStatChange = (stat, value) => {
    setCharacterStats(prev => ({
      ...prev,
      [stat]: parseInt(value) || 0
    }));
  };
  
  const calculateDamage = () => {
    // This is a placeholder for actual damage calculation logic
    // In a real app, this would use complex formulas based on game mechanics
    let baseDamage = 0;
    
    if (selectedFruit) {
      baseDamage += characterStats.fruitMastery * 1.5;
    }
    
    if (selectedWeapon) {
      baseDamage += characterStats.swordMastery * 1.2;
    }
    
    baseDamage += characterStats.strength * 0.8;
    
    setDamageOutput({
      total: Math.round(baseDamage),
      breakdown: {
        strength: Math.round(characterStats.strength * 0.8),
        fruit: selectedFruit ? Math.round(characterStats.fruitMastery * 1.5) : 0,
        weapon: selectedWeapon ? Math.round(characterStats.swordMastery * 1.2) : 0
      }
    });
  };
  
  const saveBuild = () => {
    const build = {
      stats: characterStats,
      fruit: selectedFruit,
      weapon: selectedWeapon,
      timestamp: new Date().toISOString()
    };
    
    const savedBuilds = JSON.parse(localStorage.getItem('bloxFruitBuilds') || '[]');
    savedBuilds.push(build);
    localStorage.setItem('bloxFruitBuilds', JSON.stringify(savedBuilds));
    
    alert('Build saved successfully!');
  };
  
  return (
    <div>
      <h1 className={`text-3xl font-bold mb-6 ${darkMode ? 'text-gray-100' : 'text-gray-900'}`}>
        Calculator Dashboard
      </h1>
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
        <div className="lg:col-span-2">
          <CharacterBuild 
            stats={characterStats}
            onStatChange={handleStatChange}
            onFruitSelect={setSelectedFruit}
            onWeaponSelect={setSelectedWeapon}
            darkMode={darkMode}
          />
          
          <div className="mt-6 flex flex-wrap gap-4">
            <button 
              onClick={calculateDamage} 
              className={`px-6 py-3 rounded-lg font-medium transition-colors ${
                darkMode 
                  ? 'bg-green-700 text-white hover:bg-green-600' 
                  : 'bg-green-600 text-white hover:bg-green-700'
              }`}
            >
              Calculate Damage
            </button>
            <button 
              onClick={saveBuild} 
              className={`px-6 py-3 rounded-lg font-medium transition-colors ${
                darkMode 
                  ? 'bg-primary-dark text-white hover:bg-blue-700' 
                  : 'bg-primary-light text-white hover:bg-blue-700'
              }`}
            >
              Save Build
            </button>
          </div>
        </div>
        
        <div>
          <DamageCalculator 
            stats={characterStats}
            fruit={selectedFruit}
            weapon={selectedWeapon}
            damageOutput={damageOutput}
            darkMode={darkMode}
          />
        </div>
      </div>
      
      {damageOutput && (
        <div className="mt-8">
          <h2 className={`text-2xl font-bold mb-4 ${darkMode ? 'text-gray-100' : 'text-gray-900'}`}>
            Damage Analysis
          </h2>
          <Charts damageData={damageOutput} darkMode={darkMode} />
        </div>
      )}
    </div>
  );
};

export default CalculatorDashboard;
